import React, {PropTypes} from 'react';
import Form, {DateInput, FormActions, FormBody, SelectInput} from "../../Form";
import {action, observable, toJS} from 'mobx';
import {observer, inject} from 'mobx-react';
import GraphView from '../../GraphView';
import moment from "moment/moment";
import * as api from "../../../actions/api";
import Spinner from "../../Spinner";
import {getDisplayDate} from "../../../libs/date";
const _ = require('lodash');

@inject('stationStore', 'dataSeriesStore')
@observer
export default class WindRoseNew extends React.Component {

    static contextTypes = {
        notify: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
    };

    static propTypes = {
        params: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
    };

    @observable filters = {
        station_id: null,
        date_from: getDisplayDate(moment().utc().add(-6, 'days'), {format: 'YYYY-MM-DD[T]HH:mm'}),
        date_to: getDisplayDate(moment().utc(), {format: 'YYYY-MM-DD[T]HH:mm'}),
        windSpeedDataSeries: '',
        windDirectionDataSeries: ''
    };

    @observable station = {};
    @observable stations = [];
    @observable data = null;
    @observable loading = false;
    @observable windSpeedObservations = null;
    @observable windDirectionObservations = null;

    @observable dataSeries = [];

    componentWillMount() {
        const { notify } = this.context;
        const { params: { id }, stationStore } = this.props;

        api.station.fetchAll()
            .then(action(stations => {
                this.stations = stations.sort((a, b) => (a.name > b.name) ? 1 : -1);
            }))
            .catch(notify.error);
    }

    @action onChangeStationFilter = (e) => {
        this.filters.station_id = e.target.value;

        api.station.fetchDataSeries(e.target.value)
            .then(action(dataSeries => {
                this.dataSeries = dataSeries;
            }));
    }

    @action onChangeDateFrom = (e) => this.filters.date_from = e.target.value;
    @action onChangeDateTo = (e) => this.filters.date_to = e.target.value;
    @action onChangeWindSpeedDataSeries = (e) => this.filters.windSpeedDataSeries = e.target.value;
    @action onChangeWindDirectionDataSeries = (e) => this.filters.windDirectionDataSeries = e.target.value;

    @action showObservations = (e) => {
        const { notify } = this.context;
        e.preventDefault();

        this.data = null;
        this.windSpeedObservations = null;
        this.windDirectionObservations = null;
        this.loading = true;

        const er = message => notify.error({ message });

        if (!this.filters.station_id) { return er('Station filter required'); }
        if (!this.filters.date_from) { return er('Start date filter required'); }
        if (!this.filters.date_to) { return er('End date filter required'); }
        if (this.filters.windDirectionDataSeries === '') { return er('Wind direction data series required'); }
        if (this.filters.windSpeedDataSeries === '') { return er('Wind speed data series filter required'); }

        api.observation.fetchAll({
            series_id: this.filters.windDirectionDataSeries,
            date_from: this.filters.date_from,
            date_to: this.filters.date_to
        }).then(windDirectionRes => {
            api.observation.fetchAll({
                series_id: this.filters.windSpeedDataSeries,
                date_from: this.filters.date_from,
                date_to: this.filters.date_to
            }).then(windSpeedRes => {
                this.loading = false;

                if (windSpeedRes && windSpeedRes.data && windDirectionRes && windDirectionRes.data) {
                    const selectedStation = this.stations.find(station => +station.id === +this.filters.station_id);

                    const data = {
                        id: this.filters.station_id,
                        name: selectedStation.name,
                        wind_rose: []
                    };

                    windSpeedRes.data.forEach(windSpeed => {
                        const correspondingWindDirection = windDirectionRes.data.find(windDirection => new Date(windDirection.datetime).getTime() === new Date(windSpeed.datetime).getTime());

                        if(correspondingWindDirection) {
                            data.wind_rose.push({
                                time: windSpeed.datetime,
                                speed: windSpeed.value,
                                direction: correspondingWindDirection.value
                            })
                        }
                    });

                    this.data = data;
                }
            }).catch(err => {
                this.loading = false;
                er(err);
            });
        }).catch(err => {
            this.loading = false;
            er(err);
        });

        // api.station
        //     .fetchWindRoseObservation(this.filters.station_id, this.filters.date_from, this.filters.date_to)
        //     .then(res => {
        //         this.loading = false;
        //         this.data = res[0];
        //     })
        //     .catch(err => {
        //         this.loading = false;
        //         er(err);
        //     });
    };

    postProcessor = (res) => {
        // res.map(station => {

        let windSpeedSeries = {unit: 'm/s'};
        // windSpeedObservation = res.wind_speed,
        // windDirectionObservation = res.wind_direction;

        let windRoseObservation = [{
            name: '< 0.5 ' + windSpeedSeries.unit,
            data: []
        }, {
            name: '0.5 > 2 ' + windSpeedSeries.unit,
            data: []
        }, {
            name: '2 > 4 ' + windSpeedSeries.unit,
            data: []
        }, {
            name: '4 > 6 ' + windSpeedSeries.unit,
            data: []
        }, {
            name: '6 > 8 ' + windSpeedSeries.unit,
            data: []
        }, {
            name: '8 > 10 ' + windSpeedSeries.unit,
            data: []
        }, {
            name: '> 10 ' + windSpeedSeries.unit,
            data: []
        }];

        let speedDirectionArray = res.wind_rose;

        // windDirectionObservation.map(direction => {
        //   let speed = windSpeedObservation.find(item => item.time == direction.time);
        //   if (!!speed && speed.value !== null && direction.value !== null) {
        //     speedDirectionArray.push({
        //       direction: direction.value,
        //       speed: speed.value
        //     })
        //   }
        // });


        const categories = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];

        let arr0 = _.groupBy(speedDirectionArray.filter(item => item.speed < 0.5), item => categories[Math.floor(item.direction / 22.5)]),
            arr1 = _.groupBy(speedDirectionArray.filter(item => item.speed >= 0.5 && item.speed < 2), item => categories[Math.floor(item.direction / 22.5)]),
            arr2 = _.groupBy(speedDirectionArray.filter(item => item.speed >= 2 && item.speed < 4), item => categories[Math.floor(item.direction / 22.5)]),
            arr3 = _.groupBy(speedDirectionArray.filter(item => item.speed >= 4 && item.speed < 6), item => categories[Math.floor(item.direction / 22.5)]),
            arr4 = _.groupBy(speedDirectionArray.filter(item => item.speed >= 6 && item.speed < 8), item => categories[Math.floor(item.direction / 22.5)]),
            arr5 = _.groupBy(speedDirectionArray.filter(item => item.speed >= 8 && item.speed < 10), item => categories[Math.floor(item.direction / 22.5)]),
            arr6 = _.groupBy(speedDirectionArray.filter(item => item.speed >= 10), item => categories[Math.floor(item.direction / 22.5)]);

        Object.keys(arr0).map(key => {
            let percentage0 = arr0[key] && arr0[key].length ? arr0[key].length / speedDirectionArray.length * 100 : 0;
            windRoseObservation[0].data.push([categories.indexOf(key), Math.round(percentage0 * 100) / 100])
        });

        Object.keys(arr1).map(key => {
            let percentage1 = arr1[key] && arr1[key].length ? arr1[key].length / speedDirectionArray.length * 100 : 0;
            windRoseObservation[1].data.push([categories.indexOf(key), Math.round(percentage1 * 100) / 100])
        });

        Object.keys(arr2).map(key => {
            let percentage2 = arr2[key] && arr2[key].length ? arr2[key].length / speedDirectionArray.length * 100 : 0;
            windRoseObservation[2].data.push([categories.indexOf(key), Math.round(percentage2 * 100) / 100])
        });

        Object.keys(arr3).map(key => {
            let percentage3 = arr3[key] && arr3[key].length ? arr3[key].length / speedDirectionArray.length * 100 : 0;
            windRoseObservation[3].data.push([categories.indexOf(key), Math.round(percentage3 * 100) / 100])
        });

        Object.keys(arr4).map(key => {
            let percentage4 = arr4[key] && arr4[key].length ? arr4[key].length / speedDirectionArray.length * 100 : 0;
            windRoseObservation[4].data.push([categories.indexOf(key), Math.round(percentage4 * 100) / 100])
        });

        Object.keys(arr5).map(key => {
            let percentage5 = arr5[key] && arr5[key].length ? arr5[key].length / speedDirectionArray.length * 100 : 0;
            windRoseObservation[5].data.push([categories.indexOf(key), Math.round(percentage5 * 100) / 100])
        });

        Object.keys(arr6).map(key => {
            let percentage6 = arr6[key] && arr6[key].length ? arr6[key].length / speedDirectionArray.length * 100 : 0;
            windRoseObservation[6].data.push([categories.indexOf(key), Math.round(percentage6 * 100) / 100])
        });

        return {
            name: res.name,
            observation: windRoseObservation
        }

    };

    render() {
        const categories = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
        let processedData = !!this.data && !!this.data.wind_rose && this.data.wind_rose.length > 0 ? this.postProcessor(toJS(this.data), this.date_from, this.date_to) : null;

        let options = processedData ? {
            series: processedData.observation,
            chart: {
                polar: true,
                type: 'column'
            },
            title: {
                text: `${processedData.name}`
            },
            subtitle: {
                text: 'Wind Rose',
            },
            pane: {
                size: '85%'
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                y: 100,
                layout: 'vertical'
            },
            xAxis: {
                min: 0,
                max: 16,
                type: "category",
                tickInterval: 2,
                minRange: 1,
                tickmarkPlacement: 'on',
                showEmpty: true,
                labels: {
                    formatter: function () {
                        return categories[this.value] + '°';
                    }
                }
            },
            yAxis: {
                min: 0,
                endOnTick: false,
                showLastLabel: true,
                title: {
                    text: 'Frequency (%)'
                },
                labels: {
                    formatter: function () {
                        return this.value + '%';
                    }
                },
                reversedStacks: false
            },
            tooltip: {
                useHTML: true,
                formatter: function(){
                    const {name, color} = this.series;
                    return `<div style="width: 120px">
            <p>${categories[this.x]}</p>
            <div style=${`"height: 10px; width: 10px; border: 1px solid white; border-radius: 10px; background-color: ${color}"`}/>
            <div style="display: inline-flex; width: 100px; margin-left: 10px;">
              <b style="margin: 0 2px">${name}</b>:
              <p style="margin: 0 2px">${this.y}%</p>
            </div>
          </div>`
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    shadow: false,
                    groupPadding: 0,
                    pointPlacement: 'on'
                }
            }
        } : null;
        return (
            <div>
                <Form>
                    <FormBody>
                        <SelectInput
                            filterOptions={this.props.stationStore.filterStations}
                            label={'Station'}
                            value={this.filters.station_id}
                            fields={{ label: 'name', value: 'id' }}
                            options={this.stations}
                            onChange={this.onChangeStationFilter}
                        />
                        <DateInput
                            type={'datetime-local'}
                            label={'Date From'}
                            value={this.filters.date_from}
                            onChange={this.onChangeDateFrom}
                        />
                        <DateInput
                            type={'datetime-local'}
                            label={'Date To'}
                            value={this.filters.date_to}
                            onChange={this.onChangeDateTo}
                        />
                        <SelectInput
                            label={'Wind Speed'}
                            value={this.filters.windSpeedDataSeries}
                            fields={{ label: 'name', value: 'id' }}
                            options={this.dataSeries}
                            onChange={this.onChangeWindSpeedDataSeries}
                        />
                        <SelectInput
                            label={'Wind Direction'}
                            value={this.filters.windDirectionDataSeries}
                            fields={{ label: 'name', value: 'id' }}
                            options={this.dataSeries}
                            onChange={this.onChangeWindDirectionDataSeries}
                        />
                    </FormBody>
                    <FormActions>
                        <button onClick={this.showObservations}>View</button>
                    </FormActions>
                </Form>
                <div>
                    {this.loading && <Spinner/>}
                    {!!this.data && !!options && <GraphView options={options} />}
                    {!!this.data && !options && <p>Couldn't get wind rose data for station {this.data.name}</p>}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Analysis/Meteorological/WindRoseNew.js